export const SITE_URL = 'https://homvisit.com'
export const SITE_NAME = 'Homvisit'
export const CONTACT_EMAIL = 'sujithvijayan@homvisit.com'
export const CONTACT_PHONE_DISPLAY = '75 9409 9409'
export const CONTACT_PHONE_E164 = '917594099409'
export const CONTACT_PHONE_TEL = '+917594099409'
export const WHATSAPP_URL = `https://wa.me/${CONTACT_PHONE_E164}`
export const LOCATION_LINE = 'Trivandrum, Kerala, India'
